import { ErrorHandler, provideAppInitializer } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { patchDialogForPlaidOverlayLayering } from '@app/shared/services/plaid-overlay-layering-patch';
import { routerProviders } from './core/providers/router.providers';
import { storeProviders } from './core/providers/store.providers';
import { thirdPartyProviders } from './core/providers/third-party.providers';
import { AppStorage } from '@app/shared/services/cookies/app-storage';
import { CookieStorage } from '@app/shared/services/cookies/cookie.storage';
import { Services } from '@app/shared/services';
import { provideLottieOptions } from 'ngx-lottie';
import { authInterceptor } from './shared/interceptor/auth.interceptor';

class MyErrorHandler implements ErrorHandler {
  handleError(error: any) {
    console.error(error);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAppInitializer(() => patchDialogForPlaidOverlayLayering()),
    provideLottieOptions({
      player: () => import('lottie-web')
    }),
    routerProviders,
    ...storeProviders,
    ...thirdPartyProviders,
    { provide: ErrorHandler, useClass: MyErrorHandler },
    { provide: AppStorage, useClass: CookieStorage },
    ...Services
  ]
};
